import React from 'react'
import styled from 'styled-components'
import PageHero from './../components/PageHero'

const ChectoutPage = () => {
  return (
    <main>
      <PageHero title='checkout' />
      <Wrapper className='page'>
        <h1>checkout page</h1>
      </Wrapper>
    </main>
  )
}
const Wrapper = styled.div``
export default ChectoutPage
